import React, { Component } from 'react';
//import { Card, CardTitle, CardText, CardImg, CardImgOverlay } from 'reactstrap';
import { CardDeck, Card, CardImg, CardBody, CardTitle, CardSubtitle, CardText, CardImgOverlay } from 'reactstrap';
import { Row, Col, Button, Alert, Badge  } from 'reactstrap';
import { Table } from 'reactstrap';
import { Media } from 'reactstrap';
//import { Toast, ToastBody, ToastHeader, Spinner } from 'reactstrap';
import './map.css';
// <CardImg width="100%" src="/images/Google_Map-View-1280x977.png" alt="Google Map, Directions" />
// https://react-bootstrap.github.io/components/table/
// https://reactstrap.github.io/components/media/

const WEEK_START = '9 am';
const WEEK_END = '6 pm';
const THUR_END = '8 pm';
const FRI_END = '8 pm';
const SAT_START = '9 am';
const SAT_END = '5 pm';

export class Map extends Component {
    static displayName = Map.name;

    render() {
        return (
            <div>
                <div className='div-map'>
                    <Row>
                        <Col sm="6">
                            <Card body className="shadow-lg p-0">
                                {/*<CardImg variant="top" src="/images/Google_Map_Street_Vew-530x275.png" alt="Pacific Google Street View" />*/}
                                <Button color="link" size="lg" outline><span>
                                    <a target="_blank" href='https://www.google.com/maps/search/100-6260+Graybar+Rd,+Richmond,+BC+V6W+1H6/@49.1692749,-122.9898819,19z'>
                                        Open Google Map
                                </a></span>
                                </Button>
                            </Card>
                        </Col>
                        <Col sm="6">
                            <Card body className="shadow-lg">
                                <CardTitle>
                                    <img
                                        width={30}
                                        height={30}
                                        className="mr-3"
                                        src="/images/Hours-of-operation.png"
                                        alt="Hours of operation"
                                    /><b>Hours of Operation</b>
                                    </CardTitle>
                                <CardText>
                                    <Table responsive size="sm">
                                        { /*<thead>
                                            <tr>
                                                <th>Tue-Sat:</th><th>10am</th><th>5pm</th>
                                            </tr>
                                        </thead>*/}
                                        <tbody>
                                            <tr>
                                                <td>Tue:</td><td>{WEEK_START}</td><td>{WEEK_END}</td>
                                            </tr>
                                            <tr>
                                                <td>Wed:</td><td>{WEEK_START}</td><td>{WEEK_END}</td>
                                            </tr>
                                            <tr>
                                                <td>Thu:</td><td>{WEEK_START}</td><td>{THUR_END}</td>
                                            </tr>
                                            <tr>
                                                <td>Fri:</td><td>{WEEK_START}</td><td>{FRI_END}</td>
                                            </tr>
                                            <tr>
                                                <td>Sat:</td><td>{SAT_START}</td><td>{SAT_END}</td>
                                            </tr>
                                            <tr>
                                                <td>Sun, Mon:</td><td>Closed</td><td></td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </CardText>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/Map/index.js